import {appLocalStorage, RoleUser} from "./AppConts";
import AppEnv from "../AppEnv";


export function setCharAt(str, index, chr) {
    if(index > str.length-1) return str;
    return str.substring(0,index) + chr + str.substring(index+1);
}


export function copyStringToClipboard (string) {
    function handler (event){
        event.clipboardData.setData('text/plain', string);
        event.preventDefault();
        document.removeEventListener('copy', handler, true);
    }

    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
}

export function isUserUnauthorized() {
    return !isAuthorized();
}

export function isAuthorized() {
    const user = localStorage.getItem(appLocalStorage.USER);
    const tokenNode = localStorage.getItem(appLocalStorage.TOKENNODE);
    if (user && tokenNode) {
        return true;
    }
    logoutAuthorized();
    return false;
}

export function isErrorUnauthorized(err) {
    if (err && err.status && [401, 403].indexOf(err.status) !== -1){
        return true;
    }
    return err && err.response && err.response.status && [401, 403].indexOf(err.response.status) !== -1;
}

export function isErrorNetwork(err) {
    return err && err.message && err.message === 'Network Error';
}

export function isUserAdmin(user) {
    return user && user.role === RoleUser.ROLE_ADMIN;
}

export function isUserMaster(user) {
    return user && user.role === RoleUser.ROLE_MASTER;
}

export function getStoreLocal() {
    try {
        let s = localStorage.getItem(appLocalStorage.STORE);
        return s ? JSON.parse(s) : null
    } catch (e) {
        return null;
    }
}

export function getUserLocal() {
    try {
        let s = localStorage.getItem(appLocalStorage.USER);
        return s ? JSON.parse(s) : null;
    } catch (e) {
        return null;
    }
}

export function setCustomerBook(customer) {
    try {
        localStorage.setItem(appLocalStorage.CUSTOMER_BOOK, JSON.stringify(customer))
    } catch (e) {
        console.error(e.message, e);
    }
}

export function getCustomerBook() {
    try {
        let s = localStorage.getItem(appLocalStorage.CUSTOMER_BOOK);
        return s ? JSON.parse(s) : null;
    } catch (e) {
        return null;
    }
}

export function getCheckinBooking() {
    try {
        let s = localStorage.getItem(appLocalStorage.CHECKIN_BOOK);
        return s ? JSON.parse(s) : null
    } catch (e) {
        return null;
    }
}

export function getBearerTokenJava() {
    try {
        let token = localStorage.getItem(appLocalStorage.TOKEN) || "";
        if (token) {
            return AppEnv.BEAR_TOKEN_JAVA + token;
        }
    } catch (e) {
        console.error(e);
    }
    return "";
}

export function getBearerTokenNode() {
    try {
        let token = localStorage.getItem(appLocalStorage.TOKENNODE);
        if (token) {
            return AppEnv.BEAR_TOKEN_NODE + token;
        }
    } catch (e) {
        console.error(e);
    }
    return "";
}

export function leaveStore() {
    localStorage.removeItem(appLocalStorage.STORE);
}


export function logoutAuthorized() {
    localStorage.removeItem(appLocalStorage.USER);
    localStorage.removeItem(appLocalStorage.TOKENNODE);
    localStorage.removeItem(appLocalStorage.TOKEN);
    localStorage.removeItem(appLocalStorage.STORE);
}
